import { config } from '@abyss/ui/tools/config';
import { getFeature } from 'src/tools/features';
import { useQuery } from '../../tools/useQuery';

const url = `${
  getFeature('OHID_SESSION_REWORK')
    ? `${config('IDENTITY_API_URL')}/userinfo/v2`
    : `${config('IDENTITY_API_URL')}/userinfo`
}`;

const parseResult = result => {
  const initialState = {};

  if (result) {
    return result;
  }

  return initialState;
};

export const useUserLookup = options => {
  const queryOptions = options;
  queryOptions.method = 'GET';

  const [queryResult, queryAction] = useQuery(url, {
    ...queryOptions,
    onCompleted: result => {
      options.onCompleted(parseResult(result.body));
    },
    onError: error => {
      const id = 'technical-user-get-user-info';
      const errorMessage = error.message || '';
      let code = error.statusCode;
      let type;
      if (
        errorMessage === 'Could not find user with given UUID.' ||
        errorMessage ===
          'ESSO service responded with errors and status code 200'
      ) {
        code = 'USER_NOT_FOUND';
        type = 'warning';
      }
      options.onError({ ...error, id, code, type });
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
